<template>
	<v-row>
		<v-col>
			<system-file-list />
		</v-col>
	</v-row>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({});
</script>
